import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import RemoveProfessionalDialog from 'pages/Modals/RemoveProfessionalModal'
import { FaMinus, FaStar } from 'react-icons/fa'
import ReactTooltip from 'react-tooltip'
import { DateTime } from 'luxon'

import {
  Container,
  RatingContainer,
  DeletedBadge,
  Option,
  Image,
  Label,
  SubTitle,
  SmallText
} from './styles'

export default function Professional ({
  data: professional,
  onRemove: handleRemove
}) {
  const [loading, setLoading] = useState (false)
  const [showOptionsMenu, setShowOptionsMenu] = useState (false)
  const [showRemoveDialog, setShowRemoveDialog] = useState (false)
  const token = AuthService.getToken ()
  const businessId = AuthService.getBusinessId ()
  const navigate = useNavigate ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }
  
  const goToEditPage = () => {
    navigate (`/business/professionals/${professional.id}/edit`)
  }

  const removeProfessional = async (
    startDate = DateTime.now ().toISODate (),
    endDate = DateTime.now ().plus ({years: 100}).toISODate (),
    startTime = '00:00',
    endTime = '23:59'
  ) => {
    setLoading (true)
    const filters = `?start_date=${startDate}&end_date=${endDate}`
                  + `&start_time=${startTime}&end_time=${endTime}`

    try {
      await cutileiApi.get (
        `/businesses/${businessId}/professionals/${professional.id}/notify_absence${filters}`,
        requestConfig
      )
      setLoading (false)
    } catch (error) {
      setLoading (false)
      logApiError (error)
    }
  }

  const toggleRemoveDialog = () => setShowRemoveDialog (!showRemoveDialog)

  const professionalOptions = [
    {
      name: 'Editar profissional',
      area: 'business_config.professionals',
      action: 'edit',
      onClick: goToEditPage
    },
    {
      name: 'Remover da agenda',
      area: 'agenda',
      action: 'delete',
      onClick: toggleRemoveDialog
    }
  ].filter (option => (
    AuthService.hasPermission (option.area, option.action) ||
    AuthService.hasPermission (option.area, option.action)
  ))

  return (
    <Container
      onMouseEnter={() => setShowOptionsMenu (true)}
      onMouseLeave={() => setShowOptionsMenu (false)}
      showOptionsMenu={showOptionsMenu}
    >
      <Image src={professional.profile_picture}/>
      {professional.deleted && (
        <DeletedBadge
          onMouseEnter={() => setShowOptionsMenu (false)}
          onMouseLeave={() => setShowOptionsMenu (true)}
          data-for={professional.id}
          data-tip
        >
          <FaMinus size={12} color='#FFFFFF'/>
          <ReactTooltip
            id={professional.id}
            effect='solid'
            place='bottom'
            backgroundColor='#252525'
            tooltipRadius={10}
          >
            <Label style={{width: 300}}>
              {'Este(a) profissional foi excluído(a). '
              + 'Ele(a) aparecerá na agenda nos dias em que tiver horários agendados, '
              + 'mas não irá aparecer para os clientes Cutilei.'}
            </Label>
          </ReactTooltip>
        </DeletedBadge>
      )}
      {professional.ratings_count > 0 && (
        <RatingContainer>
          <FaStar size={12} color='#FFC100'/>
          <SubTitle>
            {professional.average_rating}
          </SubTitle>
        </RatingContainer>
      )}
      <SmallText>
        {professional.nickname}
      </SmallText>
      <div className='options-menu'>
        {professionalOptions.map ((option, index) => (
          <Option key={index} onClick={option.onClick}>
            {option.name}
          </Option>
        ))}
      </div>
      <RemoveProfessionalDialog
        visible={showRemoveDialog}
        title={`Deseja remover ${professional.nickname} da agenda?`}
        professional={professional}
        onConfirm={handleRemove}
        onClose={toggleRemoveDialog}
        notifyAbsence={removeProfessional}
      />
    </Container>
  )
}
